import { createSlice } from '@reduxjs/toolkit';
import { SearchItem, SearchWorkflowSummary } from './search/types';

const initialState: {
  search: {
    results: SearchItem[];
    error: string | null;
    workflowSummary: SearchWorkflowSummary[];
    loading: boolean;
  };
  module: string;
  calendarToken: any[];
  notificationNudge: any;
  suggestionNudge: any;
  superSetDetails: any;
  loader: boolean;
} = {
  notificationNudge: {
    notifications: [],
    notificationFilter: [],
  },
  suggestionNudge: {
    suggestions: [],
    suggestionsFilter: [],
  },
  search: {
    results: [],
    workflowSummary: [],
    error: null,
    loading: false,
  },

  module: '',
  calendarToken: [],
  superSetDetails: [],
  loader: false,
};

export const navbarSlice = createSlice({
  name: 'navbar',
  initialState,
  reducers: {
    setNotifications(state, action) {
      state.notificationNudge.notifications = action.payload.notifications;
      state.notificationNudge.notificationFilter = action.payload.filters;
    },

    setLoading(state, action) {
      state.loader = action.payload;
    },

    setSuggestions(state, action) {
      state.suggestionNudge.suggestions = action.payload.suggestions;
    },

    setSearchLoading(state, action) {
      state.search.loading = action.payload;
    },

    setSearchResults(state, action) {
      state.search.results = action.payload;
    },
    setSearchError(state, action) {
      state.search.error = action.payload;
    },
    setSearchWorkflowSummary(state, action) {
      state.search.workflowSummary = action.payload;
    },
    setSelectedModule(state, action) {
      state.module = action.payload;
    },

    setCalenderTokens(state, action) {
      state.calendarToken = action.payload;
    },

    setSuperSetDetails(state, action) {
      state.superSetDetails = action.payload;
    },
  },
});

export const {
  setNotifications,
  setSuggestions,
  setSearchResults,
  setSearchError,
  setSelectedModule,
  setCalenderTokens,
  setSearchWorkflowSummary,
  setSuperSetDetails,
  setSearchLoading,
} = navbarSlice.actions;
const reducer = { navbar: navbarSlice.reducer };
export default reducer;
